"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDigits = toDigits;
/**
 * Extracts and returns only the digit characters from the input string.
 *
 * @param {string} input - The string from which to extract digits.
 * @returns {string} A string containing only the digit characters from the input.
 *
 * @example
 * // Returns '123456'
 * toDigits('abc123def456');
 *
 * @example
 * // Returns '9876543210'
 * toDigits('phone: 987-654-3210');
 */
function toDigits(input) {
    return input.replace(/\D/g, '');
}
